import Toolbar from "@mui/material/Toolbar";
import { styled } from "@mui/material/styles";

const StyledToolbar = styled(Toolbar)({
  display: "inline",
  "& + .MuiToolbar-root": {
    borderLeft: "1px solid black"
  }
});

function InlineToolbar(props) {
  return <StyledToolbar disableGutters variant="dense" component="span" {...props} />;
}

export default InlineToolbar;
